module.exports = "https://images.shiksha.ws/saassets/media/ContctUSIconMob.ddf8c31d.svg";